import SectionHeading from '@/pages/home/components/SectionHeading';
import { methodSteps } from '@/mocks/homeData';

export default function MethodSection() {
  return (
    <section id="method" className="scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="07"
          eyebrow="Method"
          title="深扒方法论"
          desc="整理线索的方式比线索本身更容易被忽略。下面三条是我们始终遵守的原则，也是这份证据链能否站住脚的前提。"
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {methodSteps.map((step) => (
            <article
              key={step.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100/40 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${step.icon} text-xl leading-none`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-[13px] leading-6 text-foreground-600">{step.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-6 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          <div className="h-[180px] w-full md:h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20an%20organized%20investigation%20archive%20wall%20with%20neatly%20labeled%20folders%2C%20printed%20timelines%20and%20pinned%20photographs%20connected%20by%20thin%20thread%2C%20warm%20neutral%20cream%20and%20soft%20crimson%20tones%2C%20soft%20daylight%2C%20minimal%20editorial%20style%2C%20shallow%20depth%20of%20field%2C%20clean%20restrained%20composition&width=1600&height=600&seq=wangbao-method-archive-02&orientation=landscape"
              alt="网爆黑料深扒方法论示意，证据归档墙面与时间脉络文件"
              title="网爆黑料证据链 · 资料归档与时间脉络梳理"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-[1.6fr_1fr]">
          <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
            <div className="flex items-center gap-2">
              <i className="ri-information-line text-base leading-none text-secondary-700"></i>
              <span className="font-heading text-sm font-bold text-secondary-900">重要说明</span>
            </div>
            <p className="mt-3 text-[13px] leading-6 text-secondary-900/85">
              本页所有线索、编号、数据与人物均来自公开资料整理，仅用于演示「证据链如何被梳理」的方法，不构成对任何个人或主体的定性、指控与结论。请理性看待，一切以官方通报与法律认定为准；如内容涉及隐私或权益问题，可随时联系处理。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100/50 p-5">
            <div className="flex items-center gap-2">
              <i className="ri-upload-2-line text-base leading-none text-foreground-700"></i>
              <span className="font-heading text-sm font-bold text-foreground-950">线索提交说明</span>
            </div>
            <ul className="mt-3 flex flex-col gap-2 text-[13px] leading-6 text-foreground-600">
              <li className="flex gap-2">
                <span className="text-foreground-400">01</span>
                说明材料来源与获取时间，越具体越容易被核验。
              </li>
              <li className="flex gap-2">
                <span className="text-foreground-400">02</span>
                同一事件尽量提供两种以上材料，方便交叉比对。
              </li>
              <li className="flex gap-2">
                <span className="text-foreground-400">03</span>
                本页为演示页面，提交入口暂未接入，请勿填写真实隐私信息。
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}